export enum ButtonVariant {
  PRIMARY = 'primary', // "Primary Blue" on Figma
  SECONDARY = 'secondary', // "Secondary Blue" on Figma
  TERTIARY = 'tertiary', // "Clickable 3th Blue" on Figma
  TERTIARY_GRAY = 'tertiary-gray', // "Clickable 3th Gray" on Figma
  LINK = 'link', // "Link Blue" on Figma
  PRIMARY_WHITE = 'primary-white',
  BLACK = 'black',
  TERTIARY_WHITE = 'tertiary-white',
}

export enum ButtonSize {
  XSMALL = 'xsmall',
  SMALL = 'small',
  MEDIUM = 'medium',
  BIG = 'big'
}

export enum GenericButtonSize {
  XSMALL = 'xsmall',
  SMALL = 'small',
  MEDIUM = 'medium',
  LARGE = 'large',
}

export interface BaseButton {
  variant?: ButtonVariant
  size?: ButtonSize
  text?: string
  disabled?: boolean
  disableHover?: boolean
  isMobile?: boolean
  isFullSize?: boolean
  isLoading?: boolean
}

export interface WithIconButton extends BaseButton {
  iconCmp?: string // Icon name as imported directly in the parent (option A)
  iconName?: string // icon name as used in WrapperIcon component (option B)
  iconOptions?: object
  isIconRight?: boolean
  isLoading?: boolean
}

export enum ComponentSize {
  XSMALL = 'x-small',
  SMALL = 'small',
  MEDIUM = 'medium',
  BIG = 'big'
}
